import { useReceivedInvoicesSettings } from 'ap-openapi';
import { useMemo } from 'react';

export const useGetReceivedInvoiceSettingsService = (enabled = true) => {
  const { data, isLoading } = useReceivedInvoicesSettings({
    query: { enabled, staleTime: 0 },
  });
  return useMemo(
    () => ({
      isPaymentRequestSupportAgentEnabled:
        data?.data?.payment_request_support_agent?.is_enabled ?? false,
      isLoading,
    }),
    [data, isLoading]
  );
};
